import { Breadcrumbs, Link, Stack, Switch, Typography } from "@mui/material";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import RefreshButton from "../../../../../common/components/refresh_button";
import { useConfiguracaoObrasViewModel } from "../../viewModels/atributos_obras_cadastro_view_model";

export const AtributosObrasCadastro = () => {
  const viewModel = useConfiguracaoObrasViewModel();

  const renderToggleRow = (label: string, checked: boolean | null, onChange: (checked: boolean) => void) => (
    <div className="flex items-center justify-between">
      <Typography className="text-[1rem] font-medium">{label}</Typography>
      <div className="flex items-center gap-3">
        <Switch checked={checked ?? true} onChange={(e) => onChange(e.target.checked)} color="success" />
        <div
          className={`px-3 py-1 rounded-lg text-white text-sm font-semibold transition-all duration-200 ${checked ? "bg-green-600" : "bg-red-500"
            }`}
        >
          {checked ? "Sim" : "Não"}
        </div>
      </div>
    </div>
  );

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <PrimaryButton startIcon={null} onClick={viewModel.salvarConfiguracoes}>
                Salvar
              </PrimaryButton>
            </div>
          }
        />
      </PageTopBar>

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Obras
          </Link>
          <Typography className="text-primary-green">Configuração de Obras</Typography>
        </Breadcrumbs>

        <div className="flex gap-2 items-center w-full">
          <h1 className="text-3xl font-medium text-black dark:text-white">Configurações de Obras</h1>
          <RefreshButton onClick={viewModel.recarregarConfiguracoes} />
        </div>

        <div className="w-full flex justify-center">
          <Stack direction="row" spacing={4} className="bg-white dark:bg-gray-900 p-8 rounded-2xl shadow-md w-full justify-between">
            {renderToggleRow(
              "Exibir histórico de alteração do Checklist",
              viewModel.config.exibirDataCadastroChecklist,
              viewModel.setExibirDataCadastroChecklist
            )}

            {renderToggleRow(
              "Exibir data de registro da inspeção",
              viewModel.config.exibirDataCadastroInspecao,
              viewModel.setExibirDataCadastroInspecao
            )}

            {/*renderToggleRow(
              "Exibir campo de data e aprovação final",
              viewModel.config.exibirCampoAprovacaoFinal,
              viewModel.setExibirCampoAprovacaoFinal
            )*/}
          </Stack>
        </div>
      </div>
    </>
  );
};
